import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { ScreenSize } from '@lyceo/shared/util-models';
import { ApplicationActions } from './application.actions';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';

export const APPLICATION_FEATURE_KEY: string = 'application';

export interface ApplicationState {
  screenSize?: ScreenSize;
  guardsState: CallState;
}

export const initialApplicationState: ApplicationState = {
  screenSize: undefined,
  guardsState: LoadingState.INIT,
};

const reducer: ActionReducer<ApplicationState, Action> = createReducer(
  initialApplicationState,
  on(
    ApplicationActions.screenSizeChanged,
    (state, { screenSize }): ApplicationState => ({
      ...state,
      screenSize,
    }),
  ),
  on(
    ApplicationActions.guardsCheckStart,
    (state): ApplicationState => ({
      ...state,
      guardsState: LoadingState.LOADING,
    }),
  ),
  on(
    ApplicationActions.guardsCheckEnd,
    (state): ApplicationState => ({
      ...state,
      guardsState: LoadingState.LOADED,
    }),
  ),
);

export function applicationReducer(
  state: ApplicationState | undefined,
  action: Action,
): ApplicationState {
  return reducer(state, action);
}
